export let activeMediaStream: MediaStream | null = null;

export const setActiveMediaStream = (stream: MediaStream) => {
  activeMediaStream = stream;
};

export const stopActiveMediaStream = () => {
  if (activeMediaStream) {
    activeMediaStream.getTracks().forEach(track => track.stop());
    activeMediaStream = null;
  }
};
